export const COMPANY_FETCH = "COMPANY_FETCH";
export const COMPANY_RECEIVE = "COMPANY_RECEIVE";
export const COMPANY_HYDRATE = "COMPANY_HYDRATE";

export const DATA_POINT_FETCH = "DATA_POINT_FETCH";
export const DATA_POINT_RECEIVE = "DATA_POINT_RECEIVE";



// WEBPACK FOOTER //
// ./src/features/company/actionTypes.js